import { FC } from "react";
import { Alert, AlertProps } from "react-bootstrap";

interface SimpleAlertProps extends AlertProps {
  children: React.ReactNode;
}

const SimpleAlert: FC<SimpleAlertProps> = ({ children, ...props }) => {
  return <Alert {...props}>{children}</Alert>;
};

export default SimpleAlert;
